
interface courseDataReducer {
    list: [],
    error: string | "",
  };
  
  const initialState: courseDataReducer = {
    list: [],
    error: "",
  };


const courseDataReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case 'SET_COURSE_DATA': {
        return { ...state, list: action.data }
      }
      case 'SET_FILTER_VALUE': {
        return { ...state, filterGoals: action.data }
      }
      default:
        return state;
    }
  }


export default courseDataReducer;